import React, { useState, useRef, useEffect } from "react";
import { authenticationService } from "../../services/AuthinticationService";
import { TextInput } from "../../components/input/TextInput";
import { InputCustom } from "../../components/input/InputCustom";
import { useNavigate, useLocation } from "react-router-dom";
import SystemMessage from "../../components/customComp/SystemMessage";

export function VerificationCode() {
  const navigate = useNavigate();
  const location = useLocation();

  // pull mode/email/userID from router state; default to forgotPassword if not provided
  const {
    mode = "forgotPassword",
    userID = null,
    email = "",
  } = location.state || {};

  const [userEmail, setUserEmail] = useState(email || "");
  const [verificationCode, setVerificationCode] = useState("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const timerRef = useRef(null);
  const [systemError, setSystemError] = useState(null);
  const [systemErrorCount, setSystemErrorCount] = useState(0);

  const handleSystemError = (message) => {
    setSystemError(message);
    setSystemErrorCount((prev) => prev + 1);
  };
  const clearSystemError = () => handleSystemError(null);

  // if email not passed via state, try session storage (forgot-password flow fallback)
  useEffect(() => {
    if (!userEmail && mode === "forgotPassword") {
      const stored = sessionStorage.getItem("fpUserEmail");
      if (stored) setUserEmail(stored);
    }
  }, [mode, userEmail]);

  const startOtpTimer = () => {
    setTimeLeft(30);
    setIsTimerActive(true);
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 1) {
          clearInterval(timerRef.current);
          setIsTimerActive(false);
        }
        return prev - 1;
      });
    }, 1000);
  };

  const SubmitFunc = async () => {
    try {
      let data;
      if (mode === "forgotPassword") {
        data = await authenticationService.submitforgotPassVerfication(
          verificationCode
        );
      } else {
        data = await authenticationService.submit2fa(verificationCode, userID);
      }

      if (!data) {
        handleSystemError("Verification code invalid");
        return;
      }

      const responseData = mode === "forgotPassword" ? data.data : data;
      const status = String(responseData.status || "").toLowerCase();
      if (status === "pass") {
        const role = responseData.profile.Role;
        if (responseData.PassNeedsToChange) {
          navigate("/ResetPassword");
        } else {
          if (role === "Radiologist") navigate(`/${role}`);
          else navigate(`/${role}/Dashboard`);
        }
      } else {
        handleSystemError("Verification failed, please try again.");
      }
    } catch (err) {
      console.error("Verification error:", err);
      handleSystemError("Something went wrong. Try again later.");
    }
  };

  const onCodeChange = (e) => {
    clearSystemError();
    setVerificationCode(e.target.value);
  };

  const resendOTP = () => {
    // keep same UI/behavior; if you add an API call later, place it here
    startOtpTimer();
    return null;
  };

  return (
    <div className="p-[68px_38.5px_0px_38.5px] rounded-[32px] flex flex-col justify-self-center items-center self-center justify-start w-password h-password gap-[18px] bg-gray-800-opacity-30 border-gradient-custom ">
      <div className="w-full z-10">
        <div className="flex-col flex gap-1 items-center mb-[7px]">
          {/* Same title for both modes */}
          <TextInput
            text={"Verification code"}
            className={"text-white text-[30px] font-medium"}
          />
          {/* Same subtext + email line for both modes */}
          <TextInput
            text={"we sent the code to"}
            className={"text-[16px] text-white text-opacity-50"}
          />
          <div className={"flex"}>
            <TextInput
              text={`${userEmail || ""} `}
              className={"text-[16px] text-white text-opacity-50"}
            />
            <span
              className="link-text"
              onClick={() => navigate("/forgotPassword")}>
              edit email
            </span>
          </div>
        </div>

        <div className={"flex flex-col items-center w-full p-0"}>
          <InputCustom
            isError={false}
            containerClassName={
              "flex-col flex w-full h-full items-center z-10 mt-6"
            }
            inputClassName="bg-black bg-opacity-30 bg-blend-luminosity custom-input rounded-[10px] h-[56px] w-[429px] z-20 text-[#999999] font-normal"
            placeholder={"Verification code"}
            name={"verificationCode"}
            onChange={onCodeChange}
            value={verificationCode ?? ""}
          />
        </div>
      </div>

      <div className={"mt-[0px] z-10 cursor-pointer"}>
        <button
          type="button"
          onClick={SubmitFunc}
          className="rounded-[10px] button-glow bg-opacity-30 flex w-[429px] h-[56px] justify-center items-center flex-shrink-0 text-white
                     font-Poppins text-lg font-[500] text-[16px]">
          Send
        </button>
      </div>

      {/* Same resend area for both modes */}
      <div
        className={
          "w-full font-normal text-white z-10 mt-[.45rem] text-center text-base text-base font-normal leading-normal "
        }>
        I didn't get a code
        <span
          className={`text-[#0099FF] ${
            isTimerActive ? "" : "cursor-pointer"
          } pl-1`}
          onClick={() => (isTimerActive ? null : resendOTP())}>
          {isTimerActive ? `(${timeLeft})` : "Send Again"}
        </span>
      </div>

      {systemError && (
        <SystemMessage
          type="error"
          title="Error"
          key={`${systemError}${systemErrorCount}`}
          message={systemError}
          handleClose={clearSystemError}
        />
      )}
    </div>
  );
}
